import { useCallback } from "react";
import { useQuery } from "react-query";
import { getVatNumber } from "api/integrations";

export const useOpencxTrigger = () => {
  const triggerOpencx = useCallback(() => {
    const opencx: HTMLIFrameElement | null = document.querySelector(
      "#opencx-root iframe"
    );

    const triggerBtn: HTMLDivElement | null | undefined =
      opencx?.contentDocument?.body.querySelector(
        '[data-component="trigger/btn"]'
      );
    if (triggerBtn) {
      triggerBtn.click();
    }
  }, []);

  return { triggerOpencx };
};
export const useVatNumber = ({ enabled = true }) => {
  const { data, isSuccess } = useQuery({
    queryKey: ["getVatNumber"],
    queryFn: () => getVatNumber(),
    enabled,
  });
  return { vatNumber: data?.tax_numer, vatIsSuccess: isSuccess };
};
